import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

interface ICheyouHeadParams {
  series_or_motor_id: string
}

const getAnnouncements = async (params: ICheyouHeadParams, req?: any) => {
  const json = await fetch(
    getUrl(
      `/motor/pc/ugc/community/announcements?${serializeObject(params)}`,
      'motor.pc_ugc.api'
    ),
    {
      req,
    }
  )

  if (0 !== json?.status) {
    throw Error(json?.prompts || json.message)
  }
  return json?.data
}
export default getAnnouncements
